import React from 'react';
import { IconProps } from '../types/types';

const CSWAP: React.FC<IconProps> = (props) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" role="img" {...props}><circle cx="10" cy="10" r="10" fill="#050332"/><path d="M14.979 5.19 12.32 9.62l-1.097-1.856H8.945L7.764 9.83l1.181 1.983h2.279l1.097-1.983 2.658 4.473-1.224 2.025h-7.51L2.447 9.79l3.798-6.54h7.51l1.224 1.94Z" fill="#1F37A3"/></svg>
);

export default CSWAP;
